import actions from './actions';
import getters from './getters';
import mutations from './mutations';
var state = function state() {
  return {
    total: 0,
    items: [],
    success: false,
    successServer: true,
    cartState: 'LOADING'
  };
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};